import { EXPRESS_API } from 'configs/api/expressApi';
import { useMutation, useQueryClient } from 'react-query';
import { videoRequestKeys } from './videoRequestKeys';

type DenyVideoRequestParams = {
  videoRequestId?: string | number;
  note?: string;
};

const denyVideoRequest = async ({
  videoRequestId,
  note,
}: DenyVideoRequestParams) => {
  const response = await EXPRESS_API.put(
    `/video-requests/${videoRequestId}/deny`,
    {
      note,
    }
  );
  return response.data;
};

export const useDenyVideoRequestMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(denyVideoRequest, {
    onSuccess: () => {
      queryClient.invalidateQueries(videoRequestKeys.all());
    },
  });
};
